/**
 * DOM side of printing: renders the built sheet into a hidden iframe and
 * triggers the browser's print dialog (avoids popup blockers entirely).
 */

import { useStore } from '../store/useStore';
import { compareTasks, weekLabel } from '../types';
import { buildPrintHtml, type PrintFilter } from './printTemplate';

export function printWeek(filter: PrintFilter = 'all'): void {
  // Canonical order — the printed page matches the screen on every device.
  const tasks = Object.values(useStore.getState().tasks).sort(compareTasks);
  const printedOn = new Date().toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
  const html = buildPrintHtml(tasks, weekLabel(), filter, printedOn);

  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  iframe.onload = () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } finally {
      // Give the print dialog time to snapshot the document before cleanup.
      setTimeout(() => iframe.remove(), 60_000);
    }
  };
  iframe.srcdoc = html;
}
